import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import CollectionPortfolioTransfer from '../../../pages/Settings/Components/Users/UserInfo/components/CollectionPortfolioTransfer';
import { getUsersToTransfer } from '../../api/portfolio';
import CustomAlert from '../../designSystem/Alert';
import CustomButton from '../../designSystem/Button';
import CenteredCircularProgress from '../../designSystem/CircularProgress';
import TransferList from './Components/TransferList';

interface PortfolioTransferProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedUserId?: number;
  users?: any[];
}

const PortfolioTransfer: React.FC<PortfolioTransferProps> = (props) => {
  const { open, setOpen, selectedUserId, users } = props;
  const dispatch = useDispatch();
  const [usersOptions, setUsersOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(0);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showTypeSelection, setShowTypeSelection] = useState(true);
  const [transferType, setTransferType] = useState<
    'comercial' | 'cobranza' | null
  >(null);

  const fetchUsers = async () => {
    setLoading(true);
    const response = await getUsersToTransfer(dispatch);
    if (response) {
      setUsersOptions(response);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (open) {
      fetchUsers();
      setShowTypeSelection(true);
      setTransferType(null);
    }
  }, [open, reload]);

  const handleTypeSelection = (type: 'comercial' | 'cobranza') => {
    setTransferType(type);
    setShowTypeSelection(false);
  };

  if (loading) {
    return <CenteredCircularProgress />;
  }

  // Show type selection dialog
  if (showTypeSelection) {
    return (
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <DialogTitle>
          <Typography variant="h6">Selecciona el tipo de cartera</Typography>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              marginTop: '16px',
            }}
          >
            <CustomButton
              variant="outlined"
              onClick={() => handleTypeSelection('comercial')}
              fullWidth
              size="medium"
            >
              Cartera Comercial
            </CustomButton>
            <CustomButton
              variant="outlined"
              onClick={() => handleTypeSelection('cobranza')}
              fullWidth
              size="medium"
              disabled={!users || users.length === 0}
            >
              Cartera Cobranza
            </CustomButton>
          </div>
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
        </DialogActions>
      </Dialog>
    );
  }

  // Show comercial portfolio transfer
  if (transferType === 'comercial') {
    return (
      <div>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl">
          <DialogTitle>
            <Typography variant="h6">Transferir cartera comercial</Typography>
          </DialogTitle>
          <DialogContent>
            <TransferList
              options={usersOptions}
              setLoading={setLoading}
              setOpen={setOpen}
              reload={reload}
              setReload={setReload}
              setError={setError}
              setSuccess={setSuccess}
              selectedUserId={selectedUserId}
            />
          </DialogContent>
        </Dialog>
        <CustomAlert
          open={error}
          setOpen={setError}
          severity="error"
          text="Error al transferir la cartera"
        />
        <CustomAlert
          open={success}
          setOpen={setSuccess}
          severity="success"
          text="Cartera transferida con éxito"
        />
      </div>
    );
  }

  // Show cobranza portfolio transfer
  if (transferType === 'cobranza') {
    return (
      <CollectionPortfolioTransfer
        open={open}
        setOpen={setOpen}
        users={users || []}
      />
    );
  }

  return null;
};

export default PortfolioTransfer;
